<div class="st-item-attach-to-dialog-label">{{ 'Select a topic to attach to' }}</div>
<div class="st-item-attach-to-dialog-header">
    <mat-button-toggle-group class="st-item-attach-to-dialog-buttons-group">
        <mat-button-toggle
            class="st-item-attach-to-dialog-buttons-group__search"
            [class.st-cast-objects-checked-search]="!savedViewDropdownVisible"
            [checked]="!savedViewDropdownVisible"
            (click)="toggleTabVisibility(false)">
            @if (!savedViewDropdownVisible) {
                <mat-icon class="material-symbols-outlined">check</mat-icon>
            }
            {{ languageSettings.PSTWebCastSearchTabLabel }}
        </mat-button-toggle>
        <mat-button-toggle
            class="st-item-attach-to-dialog-buttons-group__views"
            [checked]="savedViewDropdownVisible"
            [class.st-cast-objects-checked-saved-views]="savedViewDropdownVisible"
            (click)="toggleTabVisibility(true)">
            @if (savedViewDropdownVisible) {
                <mat-icon class="material-symbols-outlined">check</mat-icon>
            }
            {{ languageSettings.PSTWebSavedViewsTabLabel }}
        </mat-button-toggle>
    </mat-button-toggle-group>

    @if (savedViewDropdownVisible) {
        <mat-form-field
            class="st-item-attach-to-dialog--views-dropdown"
            subscriptSizing="dynamic">
            <mat-label>{{ languageSettings.PSTWebCastObjectsDropDownLabel }}</mat-label>

            <mat-select
                [value]="currentViewState()?.Guid"
                [placeholder]="languageSettings.PSTWebSavedViewsLabel"
                (selectionChange)="onViewStateGuidChanged($event)">
                @for (item of selectSavedViewStates(); track item.Guid) {
                    <mat-option [value]="item.Guid">
                        {{ item.Title }}
                    </mat-option>
                }
            </mat-select>
        </mat-form-field>
    } @else {
        <div class="st-item-attach-to-dialog--search-bar">
            <st-text-field
                #searhVal
                [placeholder]="languageSettings.PSTWebSearchPlaceholder"
                (keyup.enter)="onSearchHandler(searhVal.internalValue())"
                (changed)="onSearchHandler(searhVal.internalValue())" />
        </div>
    }
</div>

@if (!selectTopics()?.length) {
    <div class="st-item-attach-to-dialog-text">
        {{ 'There is no content to attach' }}
    </div>
} @else {
    <div class="st-item-attach-to-dialog-condensed-labels">
        <span class="st-item-attach-to-dialog-condensed-labels-story">{{ languageSettings.PSTWebWireFullScreenStory }}</span>
        @if (shouldShowCustomFields()) {
            <div class="st-item-attach-to-dialog-condensed-labels-fields">
                @for (item of viewStateCustomCondensedItems(); track item.ID) {
                    @if (item) {
                        <div class="st-item-attach-to-dialog-condensed-labels-custom-field">
                            {{ item.DefaultCaption }}
                        </div>
                    }
                }
            </div>
        } @else {
            <span class="st-item-attach-to-dialog-condensed-labels-description">{{ description() }}</span>
        }
        <span
            class="st-item-attach-to-dialog-condensed-labels-desk"
            [matTooltip]="desk()">
            {{ desk() }}
        </span>
        <span
            class="st-item-attach-to-dialog-condensed-labels-owners"
            [matTooltip]="owners()">
            {{ owners() }}
        </span>
        <span
            class="st-item-attach-to-dialog-condensed-labels-status"
            [matTooltip]="status()">
            {{ status() }}
        </span>
        <span class="st-item-attach-to-dialog-condensed-labels-assignments">{{ languageSettings.PSTWebAssignmentsFilterLabel }}</span>
        <span class="st-item-attach-to-dialog-condensed-labels-stories">{{ languageSettings.PSTWebStoriesLabel }}</span>
    </div>
    <cdk-virtual-scroll-viewport
        maxBufferPx="0"
        minBufferPx="0"
        class="st-item-attach-to-dialog-viewport"
        itemSize="48">
        <div class="st-item-attach-to-dialog-viewport-topic-item">
            <mat-selection-list
                hideSingleSelectionIndicator
                [multiple]="false"
                (selectionChange)="onSelectionChange($event)">
                <mat-list-option
                    *cdkVirtualFor="let record of selectTopics(); last as isLast; trackBy: trackByGuid; templateCacheSize: 0"
                    #trigger="cdkOverlayOrigin"
                    cdkOverlayOrigin
                    [value]="record"
                    (mouseleave)="onMouseMove($event)"
                    (mouseenter)="onMouseEnter(record.Guid)">
                    <st-topic-item-condensed
                        class="st-item-attach-to-dialog-viewport-topic-item-condensed"
                        [isReadOnly]="true"
                        [data]="record" />
                    <ng-template
                        cdkConnectedOverlay
                        [cdkConnectedOverlayOrigin]="trigger"
                        [cdkConnectedOverlayOpen]="isPanelOpenForRecord(record.Guid)"
                        [cdkConnectedOverlayPositions]="connectedPositions"
                        (attach)="panelAttached()">
                        <div class="st-item-attach-to-dialog-container-overlay">
                            <div class="st-item-attach-to-dialog-container-overlay--top-row">
                                <st-topic-type
                                    mat-chip-grid
                                    class="st-item-attach-to-dialog-container-overlay__topic-type"
                                    [itemList]="globalTablesService.getListItemsForField(PSTFieldNames.PSTTopicType)"
                                    [record]="record"
                                    [value]="record?.[PSTFieldNames.PSTTopicType]" />
                                <div
                                    class="st-item-attach-to-dialog-container-overlay--status"
                                    [matTooltip]="record?.PSTTopicStatus?.id">
                                    {{ record?.PSTTopicStatus?.title }}
                                </div>
                            </div>
                            <div class="st-item-attach-to-dialog-container-overlay--title">{{ record?.Title }}</div>
                            <st-text-area-overlay
                                class="st-item-attach-to-dialog-container-overlay--desc"
                                minRows="1"
                                minHeight="1rem"
                                [disabled]="true"
                                [value]="record?.Description"
                                [placeholder]="globalTablesService.FieldDefsDict[PSTFieldNames?.Description].DefaultCaption" />
                            <div class="st-item-attach-to-dialog-container-overlay__owner">
                                <span class="st-item-attach-to-dialog-container-overlay__owner--label">
                                    {{ globalTablesService.FieldDefsDict[PSTFieldNames?.PSTTopicStoryOwner].DefaultCaption }}
                                </span>
                                <div class="st-item-attach-to-dialog-container-overlay__owner--item">
                                    @for (owner of record?.PSTTopicOwner; track owner) {
                                        <mat-basic-chip>
                                            <st-avatar
                                                small
                                                matChipAvatar
                                                [userId]="owner" />
                                            {{ owner | titlecase }}
                                        </mat-basic-chip>
                                    }
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </mat-list-option>
            </mat-selection-list>
        </div>
    </cdk-virtual-scroll-viewport>
}
<mat-divider class="st-item-attach-to-dialog-divider" />

<mat-button-toggle-group class="st-item-attach-to-dialog-button-group">
    <button
        mat-button
        class="st-item-attach-to-dialog-button-cancel"
        (click)="cancelNew()">
        {{ languageSettings.PSTWebCancelButtonLabel }}
    </button>
    <button
        mat-button
        class="st-item-attach-to-dialog-button-confirm"
        [disabled]="!selectedTopicRecord()"
        (click)="onAttachItem()">
        @if (!loading()) {
            {{ languageSettings.PSTWebAddToTopicLabel }}
        } @else {
            <st-loader
                class="st-item-attach-to-dialog-button--spinner"
                [diameter]="30"
                [strokeWidth]="5" />
        }
    </button>
</mat-button-toggle-group>
